document.addEventListener('DOMContentLoaded', function() {
    const filterBtn = document.querySelector('.filter-toggle');
    const filterDropdown = document.querySelector('.filter-dropdown');
    const searchForm = document.querySelector('#blog-search-form');
    const clearBtn = document.querySelector('.clear-filters');

    // Toggle filter dropdown
    if (filterBtn && filterDropdown) {
        filterBtn.addEventListener('click', function() {
            filterDropdown.classList.toggle('active');
            filterBtn.classList.toggle('active');
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!filterBtn.contains(e.target) && !filterDropdown.contains(e.target)) {
                filterDropdown.classList.remove('active');
                filterBtn.classList.remove('active');
            }
        });
    }

    // Handle filter form submission
    if (filterDropdown) {
        const applyBtn = filterDropdown.querySelector('.apply-filters');
        if (applyBtn) {
            applyBtn.addEventListener('click', function() {
                submitFilters();
            });
        }
    }

    // Handle search form
    if (searchForm) {
        searchForm.addEventListener('submit', function(e) {
            e.preventDefault();
            submitSearch();
        });
    }

    // Clear all filters
    if (clearBtn) {
        clearBtn.addEventListener('click', function() {
            window.location.href = window.location.pathname;
        });
    }

    function submitSearch() {
        const url = new URL(window.location);
        const searchInput = document.querySelector('#blog-search-input');
        
        // Clear all existing params
        url.searchParams.delete('s');
        url.searchParams.delete('category');

        // Add only search term
        if (searchInput && searchInput.value.trim()) {
            url.searchParams.set('s', searchInput.value.trim());
        }

        window.location.href = url.toString();
    }

    function submitFilters() {
        const url = new URL(window.location);
        const checkedBoxes = document.querySelectorAll('.filter-dropdown input[type="checkbox"]:checked');
        
        // Clear existing params
        url.searchParams.delete('s');
        url.searchParams.delete('category');

        // Add only categories
        if (checkedBoxes.length > 0) {
            const categories = Array.from(checkedBoxes).map(cb => cb.value);
            url.searchParams.set('category', categories.join(','));
        }

        window.location.href = url.toString();
    }
});